// import React from "react";
// import {
//   Box,
//   Modal,
//   Typography,
//   Button,
//   IconButton,
//   useTheme,
//   useMediaQuery,
// } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import CloseIcon from "@mui/icons-material/Close";

// const AnnouncementModal = ({ open, handleClose }) => {
//   const theme = useTheme();
//   const nav = useNavigate();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

//   const modalStyle = {
//     position: "absolute",
//     top: "50%",
//     left: "50%",
//     transform: "translate(-50%, -50%)",
//     width: isMobile ? "90%" : "500px",
//     bgcolor: "background.paper",
//     boxShadow: 30,
//     borderRadius: 4,
//     // border: "3px solid #ff0000",
//     py: 2,
//     px: 3,
//     outline: "none",
//     textAlign: "center", // Center align text for the new content
//     overflow: "hidden", // To apply background elements if desired later
//   };

//   // The direct SharePoint embed URL you provided
//   const videoEmbedUrl =
//     "https://www.facebook.com/aigampte/videos/2744754285719198";

//   return (
//     <Modal
//       open={open}
//       onClose={handleClose}
//       aria-labelledby="pte-update-modal"
//       aria-describedby="pte-august-2025-updates"
//     >
//       <Box sx={modalStyle}>
//         <IconButton
//           aria-label="close"
//           onClick={handleClose}
//           sx={{
//             position: "absolute",
//             right: 8,
//             top: 8,
//             color: (theme) => theme.palette.grey[500], // Adjust color if you add a top banner strip
//             zIndex: 2, // Ensure it's above potential background elements
//           }}
//         >
//           <CloseIcon />
//         </IconButton>

//         <Typography
//           variant="h5" // Increased variant to h4 for more prominence
//           component="h2"
//           gutterBottom
//           sx={{
//             fontWeight: "700", // Make it extra bold
//             color: "#FFDD00", // #0b1548ff , aa2010ff
//             mt: 2, // Some top margin
//             mb: 1, // Reduce bottom margin slightly
//             textShadow: `
//               -1px -1px 0 #FF0000,
//               1px -1px 0 #FF0000,
//               -1px 1px 0 #FF0000,
//               1px 1px 0 #FF0000,
//               -2px 0px 0 #FF0000,
//               2px 0px 0 #FF0000,
//               0px -2px 0 #FF0000,
//               0px 2px 0 #FF0000,
//               -2px -2px 0 #FF0000,
//               2px -2px 0 #FF0000,
//               -2px 2px 0 #FF0000,
//               2px 2px 0 #FF0000
//             `,
//             fontSize: isMobile ? "1.8rem" : "2.0rem",
//             lineHeight: 1.1,
//             letterSpacing: "0.05em",
//           }}
//         >
//           New Format- Practice Questions {/*//PTE ACADEMIC & UKVI */}
//         </Typography>

//         {/* Main Content */}
//         <Typography
//           variant="body1"
//           sx={{
//             mt: 1.5,
//             fontSize: "18px",
//             fontWeight: "bold",
//             display: "flex",
//             alignItems: "start",
//             justifyContent: "start",
//           }}
//         >
//           From August 7th 2025,&nbsp;
//           <span style={{ color: "#12089aff" }}> PTE Academic & UKVI </span>
//           &nbsp;New Format
//         </Typography>

//         <Typography
//           variant="body1"
//           sx={{
//             mb: 1,
//             fontWeight: "bold",
//             display: "flex",
//             alignItems: "start",
//             justifyContent: "start",
//           }}
//         >
//           Featuring NEW Speaking Tasks:
//         </Typography>
//         <Box
//           component="ul"
//           sx={{ pl: 2, listStyleType: "none", paddingLeft: 0, mb: 2 }}
//         >
//           <Typography
//             component="li"
//             variant="body1"
//             sx={{
//               fontWeight: "bold",
//               display: "flex",
//               alignItems: "start",
//               mx: 3,
//               mb: 0.5,
//               justifyContent: "start",
//             }}
//           >
//             <span
//               role="img"
//               aria-label="speaking-person"
//               style={{ marginRight: "8px" }}
//             >
//               🗣️
//             </span>{" "}
//             Respond to a Situation
//           </Typography>
//           <Typography
//             component="li"
//             variant="body1"
//             sx={{
//               fontWeight: "bold",
//               display: "flex",
//               alignItems: "start",
//               mx: 3,
//               mb: 0.5,
//               justifyContent: "start",
//             }}
//           >
//             <span
//               role="img"
//               aria-label="speech-bubble"
//               style={{ marginRight: "8px" }}
//             >
//               💬
//             </span>{" "}
//             Summarize Group Discussion
//           </Typography>
//         </Box>

//         {/* Video Embed */}
//         <Box
//           sx={{
//             backgroundImage: "url(Image/Gold.jpg)",
//             backgroundSize: "cover",
//             position: "relative",
//             overflow: "hidden",
//             paddingTop: "56.25%",
//             borderRadius: 2,
//             // border: "2px solid #007bff",
//             mb: 3,
//             boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
//           }}
//         >
//           <iframe
//             src={`https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(
//               "https://www.facebook.com/aigampte/videos/2744754285719198"
//             )}&show_text=0&width=500&height=281`}
//             style={{
//               position: "absolute",
//               top: "50%",
//               left: 0,
//               // bottom: 0,
//               width: "100%",
//               height: "100%",
//               border: "none",
//               transform: "translateY(-50%)",
//             }}
//             scrolling="no"
//             frameBorder="0"
//             allowFullScreen={true}
//             allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
//             title="7 Aug PTE Update"
//           />
//         </Box>
//         <Box
//           component="ul"
//           sx={{ pl: 2, listStyleType: "none", paddingLeft: 0, mb: 3 }}
//         >
//           <Typography
//             component="li"
//             variant="body1"
//             sx={{
//               display: "flex",
//               alignItems: "start",
//               mb: 0.5,
//               justifyContent: "start",
//             }}
//           >
//             <span role="img" aria-label="rocket" style={{ marginRight: "8px" }}>
//               🚀
//             </span>{" "}
//             <span style={{ fontWeight: "bold" }}>
//               Be Future-Ready : Expert-designed new practice questions.
//             </span>{" "}
//           </Typography>
//           <Typography
//             component="li"
//             variant="body1"
//             sx={{
//               display: "flex",
//               alignItems: "start",
//               mb: 0.5,
//               justifyContent: "start",
//             }}
//           >
//             <span role="img" aria-label="chart" style={{ marginRight: "8px" }}>
//               📈
//             </span>{" "}
//             <span style={{ fontWeight: "bold" }}>
//               Score Higher : AI-powered scoring.
//             </span>{" "}
//           </Typography>
//         </Box>

//         {/* Call to Action Button */}
//         <Button
//           variant="contained"
//           // Using primary.main or a custom color like banner red
//           sx={{
//             mt: 2,
//             bgcolor: "#2050D6", // Red from your banner
//             "&:hover": {
//               bgcolor: "#4947edff", // Darker red on hover
//             },
//             color: "yellow", // Ensure text is white
//             fontWeight: "bold",
//             fontSize: isMobile ? "1rem" : "1.1rem", // Adjust font size for mobile
//             py: isMobile ? 1.2 : 1.5, // Adjust padding for mobile
//             borderRadius: "10px", // More rounded like banner button
//             boxShadow: "0 4px 10px rgba(231, 76, 60, 0.4)", // Soft shadow
//             width: "80%", // Make it a bit narrower if it was fullWidth before
//             mx: "auto", // Center the button
//             display: "block", // Ensure it behaves like a block for auto margins
//           }}
//           onClick={() => nav("front/speaking")}
//         >
//           Start Practicing Today
//         </Button>
//       </Box>
//     </Modal>
//   );
// };

// export default AnnouncementModal;

import React from "react";
import {
  Box,
  Modal,
  Typography,
  Button,
  IconButton,
  useTheme,
  useMediaQuery,
  DialogContent,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";

const AnnouncementModal = ({ open, handleClose }) => {
  const theme = useTheme();
  const nav = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: isMobile ? "90%" : "500px",
    bgcolor: "background.paper",
    boxShadow: 30,
    borderRadius: 4,
    // border: "3px solid #ff0000",
    py: 2,
    px: 2,
    outline: "none",
    textAlign: "center", // Center align text for the new content
    overflow: "hidden", // To apply background elements if desired later
  };

  // The direct SharePoint embed URL you provided
  const videoEmbedUrl =
    "https://www.facebook.com/aigampte/videos/2744754285719198";

  const frontEndURL = process.env.REACT_APP_FRONTEND_URL;

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="pte-update-modal"
      aria-describedby="pte-august-2025-updates"
    >
      <Box sx={modalStyle}>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500], // Adjust color if you add a top banner strip
            zIndex: 2, // Ensure it's above potential background elements
          }}
        >
          <CloseIcon />
        </IconButton>

        <img
          src={`${frontEndURL}Image/BlackFriCover.jpg`}
          style={{ width: "100%", height: "30%", cursor: "pointer" }}
          alt="Black Friday Sale Cover"
          onClick={() => nav("front/subscription-plan")}
        />
      </Box>
    </Modal>
  );
};

export default AnnouncementModal;
